import { render, staticRenderFns } from "./newSmartMoment.vue?vue&type=template&id=62f56118&"
import script from "./newSmartMoment.vue?vue&type=script&lang=js&"
export * from "./newSmartMoment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports